<div *ngIf="cntctsLst && cntctsLst.length > 0">
    <div class="m-4">
        <button mat-flat-button [color]="'primary'" class="m-r-10" (click)="addNewContact()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
            <span class="sm:inline-block ml-2">Contacts</span>
        </button>
    </div>
    <!-- <ds-loading *ngIf="loader === true"></ds-loading> -->
    <div class="flex flex-col w-full  m-2 cntntBgrnd">
        <div class="relative flex flex-col   flex-0 ng-tns-c266-4 ">
            <div class="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4  w-full">
                <div *ngFor="let c of cntctsLst" class=" m-2 shadow p-4 bg-white rounded-lg ">
                    <div class="font-medium p-1">{{c.cntct_type_nm}}
                        <span>
                            <mat-icon class="icon-size-4 cursor-pointer" style="float: right;"
                                [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtCntct(c)">
                            </mat-icon>
                        </span>
                    </div>
                    <ng-container *ngIf="c.cntct_nm">
                        <div class="flex flex-row items-center p-1 capitalize">
                            <div class="text-xs font-medium text-secondary capitalize">
                                {{c.cntct_nm}} <span class="font-medium">- {{c.dsgnt_nm}}</span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="c.mble_ph">
                        <div class="flex flex-row items-center p-1 capitalize">
                            <div class="text-xs text-secondary">{{c.mble_ph}} <span *ngIf="c.mble2_ph">,
                                    {{c.mble2_ph}}</span></div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="c.eml_tx">
                        <div class="flex flex-row items-center p-1">
                            <div class="text-xs text-secondary break-all">{{c.eml_tx}}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>